import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

/**
 * - 아이디(이메일) 찾기 화면으로 이동
 */
export const useMoveToRecoveryId = () => {
  const navigation = useRootStackNavigation();

  return useCallback(() => {
    navigation.push('RecoveryId', {});
  }, [navigation]);
};
